import { render, staticRenderFns } from "./JciEventTypeCreate.vue?vue&type=template&id=4c1066c8"
import script from "./JciEventTypeCreate.vue?vue&type=script&lang=js"
export * from "./JciEventTypeCreate.vue?vue&type=script&lang=js"
import style0 from "./JciEventTypeCreate.vue?vue&type=style&index=0&id=4c1066c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports